export class FastSearchResponse {
   searchResult: any[];
   emisorIdSelected: string;
   optionalCheckBoxValue: boolean;
}
